import BaseFormEdit from '../../models/base.form.edit';
import moment from 'moment';
import { Component, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({})
export default class BaseEdit extends BaseFormEdit {
  initTimeout: any;
  initStatus: any;
  initStartStatus: any;
  initCtSendDate: any = '';
  isTemporary = false;

  get yesNoOptions() {
    return [
      { text: this.$t('Не выбрано'), value: '' },
      { text: this.$t('Да'), value: true },
      { text: this.$t('Нет'), value: false },
    ];
  }

  get isReasonVisible() {
    return this.currentStatus && this.currentStatus.value === 'Дополнение';
  }

  get currentStatus() {
    return this.form.statuses && this.form.status
      ? this.form.statuses.find((x: any) => x.key === this.form.status)
      : null;
  }

  get loadedStatus() {
    return this.form.statuses && this.initStatus
      ? this.form.statuses.find((x: any) => x.key === this.initStatus)
      : null;
  }

  get rejectionReasonOptions() {
    if (this.form.rejectionReasons) {
      return this.form.rejectionReasons.map((x: any) => ({
        key: x.id,
        value: x.name,
      }));
    }
    return [];
  }

  get isCollectionDonePartVisible() {
    return this.loadedStatusIn(['Сбор клеток', 'Сбор выполнен']);
  }

  get isCollectionDonePartDisabled() {
    return this.loadedStatusIn(['Сбор выполнен']);
  }

  get permanentRejectionReasonOptions() {
    if (this.form.rejectionReasons) {
      return this.form.rejectionReasons
        .filter((x: any) => !x.isTemporary)
        .map((x: any) => ({
          key: x.id,
          value: x.name,
        }));
    }
    return [];
  }

  @Watch('isDataLoaded')
  onIsDataLoadedChanged(val: string, oldVal: string) {
    if (val) {
      this.initTimeout = this.form.timeout;
      this.initStatus = this.form.status;
      this.initStartStatus = this.form.startStatus;
      this.initCtSendDate = this.form.ctSendDate;
    }
  }

  async submitWithFile(
    url: any,
    isGoBack = false,
    submitErrorCallback: any = null
  ) {
    const formData = new FormData();

    formData.append('json', JSON.stringify(this.form));
    return await this.submit(url, isGoBack, '', formData, submitErrorCallback);
  }

  protected yesNoOptionsClass(val: any) {
    if (val === '') {
      return 'outline-secondary';
    }
    return !val ? 'outline-warning' : 'outline-primary';
  }

  protected updateStatus(val: number) {
    const status = this.form.statuses.find((x: any) => x.key === val);

    if (status) {
      this.form.status = status.key;
      this.setTimeout(status);
    }
  }

  protected setTimeout(status: any) {
    if (status.value === this.$t('Дополнение') || status.value === this.$t('Запрос на заготовку')) {
      this.form.timeout = this.getTimeout();
    } else {
      this.form.timeout = this.initTimeout;
    }
  }

  protected getTimeout() {
    if (this.form.status == this.initStatus) {
      return this.initTimeout;
    } else {
      const timeout = this.form.timeouts.find(
        (t: any) => t.status == this.form.status
      );
      const value = timeout ? timeout.days : 0;
      let nowDate: Date = new Date();
      nowDate.setDate(nowDate.getDate() + value);

      return nowDate;
    }
  }

  protected statusIn(arr: String[]) {
    return this.currentStatus && arr.map(v => this.$t(v as string)).indexOf(this.currentStatus.value) > -1;
  }

  protected loadedStatusIn(arr: String[]) {
    return this.loadedStatus && arr.map(v => this.$t(v as string)).indexOf(this.loadedStatus.value) > -1;
  }

  protected getStatusByName(statusName: String) {
    return this.form.statuses.find((x: any) => x.value == this.$t(statusName as string));
  }

  protected getStatusByKey(key: Number) {
    return this.form.statuses.find((x: any) => x.key == key);
  }

  protected setDonorStatus(statusName: String) {
    const donorStatus = this.getStatusByName(statusName);

    if (donorStatus) {
      this.form.status = donorStatus.key;
      this.form.startStatus = new Date();
    }
  }

  onRemoveFile(fileTypeName: any, nextFielInfo: any) {
    if(fileTypeName == 'Согласие донора на донацию') {
      //@ts-ignore
      this.$refs.ctFileInfo.clearFiles();
      this.form.ctFileInfo = nextFielInfo;      
    }
  }
  
  get common() {
    let result = '';

    if (this.form.gender) {
      let gender = this.form.genders.filter((item: { key: any; }) => item.key === this.form.gender);
      result += `, ${gender && gender.length && gender[0].value}`;
    }

    if (this.age) {
      let birthday = moment(new Date(this.form.birthday)).format('DD.MM.YYYY');
      result += `, ${ this.age } (${ birthday })`; 
    }    

    if (this.form.bloodType) {
      let bloodType = this.form.bloodTypes.filter((item: { key: any; }) => item.key === this.form.bloodType);
      result += `, ${bloodType && bloodType.length && bloodType[0].value}`;
    }

    if (this.form.rh) {
      let rh = this.form.rhs.filter((item: { key: any; }) => item.key === this.form.rh);
      result += `, ${rh && rh.length && rh[0].value}`;
    }

    if (this.form.cmvStatus) {
      let cmvStatus = this.form.cmvStatuses.filter((item: { key: any; }) => item.key === this.form.cmvStatus);
      result += `, ${cmvStatus && cmvStatus.length && cmvStatus[0].value}`;
    }     

    return result;
  }

  get age() {
    if (!this.form.birthday) {
      return null;
    }

    const age: number | null = this.calculateAge(new Date(this.form.birthday));

    if (age == 0) {
      const month: number | null = this.calculateMonth(
        new Date(this.form.birthday)
      );

      return this.getDeclension(month, this.$t('месяц') as string, this.$t('месяца') as string, this.$t('месяцев') as string);
    } else {
      return this.getDeclension(age, this.$t('год') as string, this.$t('года') as string, this.$t('лет') as string);
    }
  }

  public getDeclension(
    num: any,
    nominativ: string,
    genetiv: string,
    plural: string
  ): string | null {
    if (num == undefined || num == null || isNaN(num)) {
      return num;
    }

    const total = num;

    num = num % 100;
    if (num >= 11 && num <= 19) {
      return total + ' ' + plural;
    }

    let declension = plural;
    const i = num % 10;

    switch (i) {
      case 1:
        declension = nominativ;
        break;
      case 2:
      case 3:
      case 4:
        declension = genetiv;
        break;
    }

    return total + ' ' + declension;
  }
}
